const isExternalLink = (url: string) => {
  const regex = /^(?:[a-z]+:)?\/\//i;
  return regex.test(url);
};

export { isExternalLink };
